import Stack from "@mui/material/Stack";
import { ButtonProps } from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { Dialog } from "../../../components/Dialog";
import { Import } from "../../../types/imports";
import { useStyles } from "../styles";
import { ArrowForward } from "@mui/icons-material";
import { map } from "lodash";
import { useQuery } from "react-query";
import { listColumns } from "../../../services/imports";

type DetailsImportProps = {
  data: Import | null;
  open: boolean;
  onClose: () => void;
};

export function DetailsImport({ data, open, onClose }: DetailsImportProps) {
  const styles = useStyles();

  const columns = useQuery(
    ["columns", data?.id_importacao],
    () => listColumns(data?.header_link),
    { enabled: Boolean(data?.id_importacao) }
  );

  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Fechar",
        onClick: onClose,
      },
    ];
  }, [onClose]);

  const typeImport = useMemo(() => {
    return {
      PESSOA: "Dados cadastrais",
      VENDAS: "Dados de vendas",
      CAMPANHA: "Dados cadastrais para campanha",
    };
  }, []);

  const ruleImport = useMemo(() => {
    return {
      update: "Substituir valores existentes",
      complete: "Completar campos em branco",
    };
  }, []);

  const RenderColumns = (item: any) => {
    return (
      <Stack key={item.column} direction="row" spacing={2}>
        <div style={{ width: "30%" }}>
          <Typography variant="subtitle2">{item.label}</Typography>
        </div>
        <div style={{ width: "100%", textAlign: "center" }}>
          <ArrowForward color="action" fontSize="small" />
        </div>
        <div style={{ width: "30%" }}>
          <Typography variant="subtitle2">{item.column}</Typography>
        </div>
      </Stack>
    );
  };

  return (
    <Dialog
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      title={data?.file_name}
      open={open}
      actions={actions}
    >
      <Stack spacing={4} className={styles.rootContent}>
        <Typography color="primary">Detalhes</Typography>
        <Typography>
          Tipo de importação: {typeImport[data?.type_import]}
        </Typography>
        <Typography>Regra: {ruleImport[data?.rule_import]}</Typography>
        <Typography>Arquivo: {data?.file_name}</Typography>
        <Typography>Colunas</Typography>
        <div className={styles.rootOptions}>
          {map(columns.data, (column) => RenderColumns(column))}
        </div>
      </Stack>
    </Dialog>
  );
}
